import React, { useState, useEffect, useRef } from "react";
import TechnologySection from "./TechnologySection";
import FutureBatteryArchitectures from "./FutureBatteryArchitectures";
import AcademicCooperation from "./AcademicCooperation";
import ScrollNav from "./BatteryArchitectureNav";

const ResearchMain: React.FC = () => {
  const [showNav, setShowNav] = useState(false);
  const technologySectionRef = useRef<HTMLDivElement>(null);
  const [sectionsReady, setSectionsReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSectionsReady(true);
    }, 500);

    const checkScrollPosition = () => {
      if (technologySectionRef.current) {
        const rect = technologySectionRef.current.getBoundingClientRect();
        setShowNav(rect.top <= 200);
      }
    };

    window.addEventListener("scroll", checkScrollPosition);
    checkScrollPosition();

    return () => {
      window.removeEventListener("scroll", checkScrollPosition);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="relative">
      {sectionsReady && (
        <div
          className={`fixed left-0 top-1/2 transform -translate-y-1/2 z-50 transition-opacity duration-300 ${
            showNav ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <ScrollNav />
        </div>
      )}

      <div className="">
        <div id="technology" ref={technologySectionRef}>
          <TechnologySection />
        </div>
        <FutureBatteryArchitectures />
        <AcademicCooperation />
      </div>
    </div>
  );
};

export default ResearchMain;
